import { render, staticRenderFns } from "./Reason.vue?vue&type=template&id=3303acb6&scoped=true&"
import script from "./Reason.vue?vue&type=script&lang=js&"
export * from "./Reason.vue?vue&type=script&lang=js&"
import style0 from "./Reason.vue?vue&type=style&index=0&id=3303acb6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3303acb6",
  null
  
)

export default component.exports